import * as React from "react";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Button } from "components/bootstrap";
import { IconButton } from "components/common";
import { Row } from "common/components/layout-styles";
import StepActionsButton from "./StepActionsButton";
const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  border-radius: ${({ theme }) => theme.spacings.xxs};
  border: 1px solid ${({ theme }) => theme.colors.misc.divider};
  background-color: ${({ theme }) => theme.colors.global.contentBackground};
  padding: 0.5rem;
  margin: 4px 0;
  height: 40px;
`;
const StyledButton = styled(Button)`
  border-radius: 4px;
`;
const StepListItem = React.forwardRef(
  ({ item, onViewStep = () => {
  }, onRemoveStep = () => {
  }, dragHandle, className }, ref) => {
    const { t } = useTranslation("enterprise_security_events");
    const handleViewStep = () => onViewStep(item == null ? void 0 : item.id);
    const handleRemoveStep = () => onRemoveStep(item == null ? void 0 : item.id);
    return /* @__PURE__ */ React.createElement(Container, { ref, className }, /* @__PURE__ */ React.createElement(Row, { $width: "auto", style: { overflow: "hidden" } }, dragHandle, /* @__PURE__ */ React.createElement("div", { style: { width: "90%", whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" } }, item == null ? void 0 : item.title)), /* @__PURE__ */ React.createElement(Row, { $width: "auto" }, /* @__PURE__ */ React.createElement(StepActionsButton, { step: item }), /* @__PURE__ */ React.createElement(
      StyledButton,
      {
        bsSize: "xs",
        bsStyle: "gray",
        onClick: handleViewStep,
        "aria-label": t("step_list_item.view_item_label", { title: item == null ? void 0 : item.title })
      },
      t("step_list_item.view")
    ), /* @__PURE__ */ React.createElement(
      IconButton,
      {
        name: "close",
        title: t("step_list_item.remove"),
        onClick: handleRemoveStep,
        "aria-label": t("step_list_item.remove_item_label", { title: item == null ? void 0 : item.title }),
        size: "sm"
      }
    )));
  }
);
export default StepListItem;
